import { Link } from 'react-router-dom';

export default function AboutSection() {
  return (
    <section id="spreadsheet" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          <div>
            <span className="inline-block px-3 py-1 bg-primary-100 text-primary-700 text-xs font-semibold rounded-full mb-4">
              Czym jest
            </span>
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-6">
              Czym jest Kakobuy Spreadsheet?
            </h2>
            <p className="text-foreground-600 leading-relaxed mb-6">
              <strong>Kakobuy Spreadsheet</strong> to uporządkowana lista produktów zawierająca linki, kategorie, informacje zakupowe oraz rekomendacje. Dzięki niej użytkownicy mogą szybciej znaleźć interesujące produkty bez ręcznego przeszukiwania wielu stron.
            </p>
            <p className="text-foreground-600 leading-relaxed mb-8">
              Niezależnie od tego, czy szukasz <strong>najlepszych sneakersów</strong>, modnych ubrań streetwear, czy unikalnych akcesoriów – <strong>Kakobuy Spreadsheet Polska</strong> pomoże Ci znaleźć dokładnie to, czego potrzebujesz. Nasze zestawienia są stale aktualizowane i zawierają wyłącznie sprawdzone pozycje.
            </p>
            <Link
              to="/blog/kakobuy-spreadsheet-polska-przewodnik"
              className="inline-flex items-center gap-2 text-primary-600 hover:text-primary-700 font-semibold text-sm transition-colors cursor-pointer no-underline"
            >
              Dowiedz się więcej z naszego poradnika
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>

          <div className="bg-background-100 rounded-2xl p-6 md:p-8 border border-background-200/70">
            <h3 className="font-heading text-xl font-semibold text-foreground-950 mb-5">Porównanie metod wyszukiwania</h3>
            <div className="overflow-x-auto">
              <table className="w-full text-sm">
                <thead>
                  <tr className="border-b border-background-200">
                    <th className="text-left py-3 pr-4 font-semibold text-foreground-800">Metoda</th>
                    <th className="text-left py-3 px-4 font-semibold text-foreground-800">Czas</th>
                    <th className="text-left py-3 px-4 font-semibold text-foreground-800">Trudność</th>
                    <th className="text-left py-3 pl-4 font-semibold text-foreground-800">Efekt</th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="border-b border-background-100">
                    <td className="py-3 pr-4 text-foreground-600">Szukanie samodzielne</td>
                    <td className="py-3 px-4 text-foreground-600">2-5 godzin</td>
                    <td className="py-3 px-4">
                      <span className="px-2 py-0.5 bg-red-100 text-red-700 rounded text-xs">Wysoki</span>
                    </td>
                    <td className="py-3 pl-4 text-foreground-600">Wiele błędów</td>
                  </tr>
                  <tr>
                    <td className="py-3 pr-4 text-primary-600 font-semibold">
                      <strong>Kakobuy Spreadsheet</strong>
                    </td>
                    <td className="py-3 px-4 text-primary-600 font-semibold">Kilka minut</td>
                    <td className="py-3 px-4">
                      <span className="px-2 py-0.5 bg-accent-100 text-accent-700 rounded text-xs">Niski</span>
                    </td>
                    <td className="py-3 pl-4 text-primary-600 font-semibold">Szybkie znalezienie</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}